import { Stack } from 'expo-router';

import { primitive } from 'styles/constants/primitives';
import { isIos } from 'utils/environment';

export default function ModalsLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        // provides similar looking modal styles in conjunction with CardModal across OS types
        ...(isIos
          ? { presentation: 'modal', contentStyle: { backgroundColor: primitive.bk.$mayoEggWhite } }
          : { presentation: 'transparentModal', contentStyle: { backgroundColor: 'transparent' } }),
      }}
    />
    // filesystem contains the routes. Page level overrides to the default config can go here if needed
  );
}
